import PropTypes from 'prop-types';

import { ORIENTATION_LEFT_TO_RIGHT, ORIENTATION_TOP_TO_BOTTOM, ORIENTATION_RIGHT_TO_LEFT, ORIENTATION_BOTTOM_TO_TOP } from './constants';

export const PointShape = PropTypes.shape({
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
});

export const OrientationShape = PropTypes.oneOf([
  ORIENTATION_LEFT_TO_RIGHT,
  ORIENTATION_TOP_TO_BOTTOM,
  ORIENTATION_RIGHT_TO_LEFT,
  ORIENTATION_BOTTOM_TO_TOP,
]);

export const RawNodeDatumShape = PropTypes.shape({
  name: PropTypes.string,
  attributes: PropTypes.object,
  children: PropTypes.array,
});

export const TreeNodeDatumShape = PropTypes.shape({
  children: PropTypes.arrayOf(RawNodeDatumShape),
  __rd3t: PropTypes.shape({
    id: PropTypes.string.isRequired,
    depth: PropTypes.number,
    collapsed: PropTypes.bool,
  }),
});

export const PathFuncShape = PropTypes.oneOfType([PropTypes.oneOf(['diagonal', 'elbow', 'straight', 'step']), PropTypes.func]);
